import { price as priceUtils, constants } from '@eti/utils';
import { Inline, Stack, Text, Button, LinkButton, textVariants, vars, breakpoints } from '@etg/wings';
import { ReactComponent as SeatIcon } from '@eti/assets/icons/Seat_thin.svg';
import { Trash, Pen } from '@phosphor-icons/react';
import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { useScrollActiveTravelerIntoView } from '../../hooks/useScrollActiveTravelerIntoView';
import { getTravelerButtonProps } from './travelerButtonUtils';
import { blackText, nonInteractiveTextStyles, removeButtonStyles, seatIconStyles, travelerCardStateStyles } from './styles';
import { ConditionalWrapper } from '@eti/components';
import { useMediaQuery } from 'usehooks-ts';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const listItemStyles = css`
  flex: 1;
  min-width: 166px;
`;
const travelerButtonMobile = {
  base: css`
    background: ${vars.colors.surface.primary};
    display: flex;
    height: 56px;
    justify-content: flex-start;
    padding-inline: 10px;
    transition:
      background 0.3s ease,
      border-color 0.3s ease;
    width: 100%;

    & > span:first-of-type {
      align-items: start;
    }
  `,
  border: travelerCardStateStyles
};
const mobileTextEllipsis = css`
  display: block;
  max-width: 120px;
  overflow: clip;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const SeatMapTravelerListItem = ({
  activeSeatAssignments,
  activeTraveler,
  id,
  isRyanairInTrip,
  name,
  onChange,
  onRemoveSeat,
  setTravelerButtonWithRemoveLink,
  travelerButtonWithRemoveLink
}) => {
  const {
    t
  } = useTranslation();
  const isNarrowViewport = useMediaQuery(`(max-width: ${breakpoints._1170})`);
  const selectedSeat = activeSeatAssignments.find(s => String(s.id) === String(id));
  const showRemove = travelerButtonWithRemoveLink === id;
  const {
    handleClick,
    handleFocus,
    isActive
  } = getTravelerButtonProps({
    activeTraveler,
    onChange,
    selectedSeat,
    setTravelerButtonWithRemoveLink,
    travelerId: id
  });
  const travelerButtonRef = useScrollActiveTravelerIntoView(isActive);
  const selectLabel = t('Seating.SelectSeat.Header.Text');
  return /*#__PURE__*/_jsx("li", {
    className: listItemStyles,
    "data-testid": `seatMapTraveler-${id}`,
    children: /*#__PURE__*/_jsx(Button, {
      "aria-current": isActive ? 'step' : undefined,
      ref: travelerButtonRef,
      className: cx(travelerButtonMobile.base, {
        [travelerButtonMobile.border.active]: isActive,
        [travelerButtonMobile.border.inactive]: !isActive
      }),
      "data-testid": `seatMapTravelerListButton-${id}`,
      id: `seatMapTravelerListButton-${id}`,
      onClick: handleClick,
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(SeatIcon, {
          className: seatIconStyles
        }), /*#__PURE__*/_jsx(ConditionalWrapper, {
          condition: Boolean(selectedSeat) || isNarrowViewport,
          wrapper: children => /*#__PURE__*/_jsx(Stack, {
            spacing: 8,
            align: "start",
            children: children
          }),
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              className: cx(mobileTextEllipsis, 'seatMap__travelerName', MOUSE_FLOW_CLASS_NAMES, blackText),
              variant: textVariants._14_BOLD,
              children: name
            }), !selectedSeat && selectLabel && /*#__PURE__*/_jsx(Text, {
              "aria-label": t('ScreenReader.Seatmap.Seat.Not.Selected.Text'),
              className: mobileTextEllipsis,
              variant: textVariants._14_BOLD,
              children: selectLabel
            }), selectedSeat && /*#__PURE__*/_jsxs(Inline, {
              noWrap: true,
              spacing: 8,
              children: [!isRyanairInTrip && /*#__PURE__*/_jsx(Text, {
                className: blackText,
                children: priceUtils.formatPrice(selectedSeat.price)
              }), /*#__PURE__*/_jsx(Text, {
                className: blackText,
                children: selectedSeat.value
              }), /*#__PURE__*/_jsx(LinkButton, {
                className: cx({
                  [removeButtonStyles.visible]: showRemove,
                  [removeButtonStyles.hidden]: !showRemove
                }),
                "data-testid": "remove-icon",
                onClick: e => {
                  e.stopPropagation();
                  onRemoveSeat();
                  setTravelerButtonWithRemoveLink(undefined);
                },
                children: /*#__PURE__*/_jsx(Trash, {
                  alt: t('Product.SeatMap.Summary.Seat.Remove'),
                  size: 20
                })
              }), !showRemove && /*#__PURE__*/_jsx("div", {
                className: nonInteractiveTextStyles,
                children: /*#__PURE__*/_jsx(LinkButton, {
                  "data-testid": "edit-icon",
                  tabIndex: -1,
                  children: /*#__PURE__*/_jsx(Pen, {
                    alt: t('Product.SeatMap.Change.Label'),
                    size: 20
                  })
                })
              })]
            })]
          })
        })]
      })
    })
  });
};
export default SeatMapTravelerListItem;
//# sourceMappingURL=SeatMapTravelerListItem.js.map